<template>
  <div class="post card mb-3">
    <div class="card-body p-5">
      <div class="d-flex mb-2">
        <div>
          <small class="">{{ studentsName }}</small>
          >
          <small class="">
            <a class="text-dark" :href="topicLink">
              {{ post.community_topic.title }}
            </a>
          </small>
          <small class="text-muted">{{ time(post.created_at) }}</small>
        </div>
      </div>
      <div>
        <a :href="postLink" class="text-dark">
          <h4 class="fw-bold" v-show="post.title">{{ post.title }}</h4>
        </a>
      </div>
      <div v-if="post.student_id" style="white-space: pre-wrap">
        {{ post.body }}
      </div>
      <div
        v-else
        style="white-space: pre-wrap"
        v-html="markdown(post.body)"
      ></div>
      <div class="mt-3" v-if="post.image">
        <img :src="imgUrl" class="img-fluid" />
      </div>
      <div class="mt-3" v-else-if="post.bunny_id && !post.bunny_status">
        <div class="ratio ratio-16x9 bg-secondary-subtle">
          <Spinner></Spinner>
        </div>
      </div>
      <div class="mt-3" v-else-if="post.bunny_id && post.bunny_status === 3">
        <div class="ratio ratio-16x9">
          <iframe
            :src="`https://iframe.mediadelivery.net/embed/25534/${post.bunny_id}?autoplay=false&preload=false`"
            loading="lazy"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowfullscreen="true"
          ></iframe>
        </div>
      </div>
      <div class="mt-3" v-else-if="post.video">
        <div class="ratio ratio-16x9">
          <iframe class="embed-responsive-item" :src="post.video"></iframe>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <Votes :votable="post"></Votes>
        <div class="ms-2">
          <router-link
            v-if="hasRouter"
            :to="{
              name: 'community.posts.show',
              params: {
                post: post.id,
              },
            }"
            class="text-dark"
          >
            <small>
              <i class="far fa-comment"></i>
              {{ post.comments_count }}
            </small>
          </router-link>
          <a :href="postLink" v-else class="text-dark">
            <small>
              <i class="far fa-comment"></i>
              {{ post.comments_count }}
            </small>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Votes from '~/player/components/Votes'
import _ from 'lodash'
import snarkdown from 'snarkdown'
import xss from 'xss'
import Spinner from '~/app2/components/Spinner'

export default {
  props: ['post'],
  components: {
    Votes,
    Spinner,
  },
  methods: {
    time(date) {
      const formatter = new Intl.RelativeTimeFormat(this.$i18n.locale(), {
        numeric: 'auto',
      })

      const DIVISIONS = [
        { amount: 60, name: 'seconds' },
        { amount: 60, name: 'minutes' },
        { amount: 24, name: 'hours' },
        { amount: 7, name: 'days' },
        { amount: 4.34524, name: 'weeks' },
        { amount: 12, name: 'months' },
        { amount: Number.POSITIVE_INFINITY, name: 'years' },
      ]

      function formatTimeAgo(date) {
        let duration = (new Date(date) - new Date()) / 1000

        for (let i = 0; i <= DIVISIONS.length; i++) {
          const division = DIVISIONS[i]
          if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.name)
          }
          duration /= division.amount
        }
      }

      return formatTimeAgo(date)
    },
    removePost() {
      this.$emit('postDelete', this.post.id)
    },
    markdown(text) {
      if (text) {
        return xss(snarkdown(text))
      }

      return ''
    },
  },
  computed: {
    studentsName() {
      return _.get(this.post, 'student.name', this.pageName)
    },
    imgUrl() {
      return `https://djceg34j53tq.cloudfront.net/${this.post.image}`
    },
    postLink() {
      return `${window.location.protocol}//${window.location.host}/community/posts/${this.post.id}`
    },
    topicLink() {
      return `${window.location.protocol}//${window.location.host}/community/topics/${this.post.community_topic.id}`
    },
    hasRouter() {
      return _.get(this, '$route.name', false)
    },
    pageName() {
      return _.get(this, '$store.state.page.name')
    },
  },
}
</script>

<style></style>
